import React from 'react';
import { func, object } from 'prop-types';

const propTypes = {
  params: object.isRequired,
  onClose: func,
};

const defaultProps = {
  params: {},
  onClose() {},
};

const CustomAlert = ({ params, onClose }) => {
  if (params.closeInSeconds) {
    setTimeout(onClose, params.closeInSeconds * 1000);
  }

  return (
    <div className={`alert-notification alert-notification_${params.alertType}`}>
      <div className="alert-notification-container container">
        <div className="alert-notification-text">
          <i className={`alert-notification-icon icon-alert-${params.alertType}`} />
          <span className="alert-notification-message">{params.message}</span>
        </div>
        {params.dismissable && (
          <button className="alert-notification-button-dismiss" onClick={onClose}>
            <i className="icon-cross-rounded" />
          </button>
        )}
      </div>
    </div>
  );
};

CustomAlert.propTypes = propTypes;
CustomAlert.defaultProps = defaultProps;

export default CustomAlert;
